import React from 'react';
import PropTypes from 'prop-types';

// helpers
import debounce from 'lodash.debounce';

/**
 * HOC for keeping track of Quick View state
 *
 * @class
 */
export class QuickViewProvider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeQuickView: null,
        };

        this.openQuickView = this.openQuickView.bind(this);
        this.closeQuickView = this.closeQuickView.bind(this);
        this.onResize = debounce(this.onResize.bind(this), 500, { leading: true });
    }
    componentDidMount() {
        window.addEventListener('resize', this.onResize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }
    onResize() {
        // close quick view when the window is re-sized
        this.closeQuickView();
    }
    openQuickView(activeQuickView) {
        this.setState({ activeQuickView });
    }
    closeQuickView() {
        this.setState({ activeQuickView: null });
    }
    render() {
        return this.props.children({
            quickView: {
                openQuickView: this.openQuickView,
                closeQuickView: this.closeQuickView,
                activeQuickView: this.state.activeQuickView,
            },
        });
    }
}

QuickViewProvider.propTypes = {
    children: PropTypes.func,
};
